const ParagraphQuestionView = ({ question, ...rest }) => {
  return (
    <div
      className="bg-white p-4 rounded-3 shadow mb-4 assessment_question"
      {...rest}
    >
      <div className="mb-2"><i>Paragraph question</i></div>
      <pre className="mb-0 assessment_question_title_view">
        <strong>{question?.title}</strong>
      </pre>
    </div>
  );
};

export default ParagraphQuestionView;
